import { MicConfig, MicImplType } from "./config";
import { MicMicrosoftSdk } from "../microsoft-sdk";
import { MicQueuingStt } from "../queuing-stt";
import { MicScriptNodeRecorder } from "../script-node-recorder";

/**
 * Build a microphone instance given a required implementation and options
 *
 * @param micConfig Microphone configuration info
 */
export const buildMic = (micConfig: MicConfig): MicImplType => {
  // QueueSTT
  if (micConfig.impl === "SttQueue") {
    const queueStt = new MicQueuingStt(micConfig.options);
    return queueStt;
  }
  // Microsoft SDK
  else if (micConfig.impl === "MicrosoftSdk") {
    const microsoftSdk = new MicMicrosoftSdk(micConfig.options);
    return microsoftSdk;
  }
  // AudioContext + ScriptNode recorder only
  else if (micConfig.impl === "ScriptNodeRecorder") {
    const recorder = new MicScriptNodeRecorder(micConfig.options);
    return recorder;
  }
  // Erf
  else {
    throw new Error(`Invalid MicConfig: ${JSON.stringify(micConfig)}`);
  }
};
